import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { modalBoxStyle } from "../styles";

// Shown right after a family's serving size presets are saved. Pushing is additive - it adds the
// family's current defaults to formats already in the library and never strips any off.
const PushFamilyServingSizesModal = ({
  isOpen,
  toggleModalOpen,
  handlePush,
}) => {
  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    toggleModalOpen(false);
    setLoading(false);
  };

  const handlePushCallback = async () => {
    setLoading(true);
    await handlePush();
    setLoading(false);
    closeModal();
  };

  return (
    <Modal
      open={isOpen}
      onClose={closeModal}
      aria-labelledby="push-serving-sizes-title"
      aria-describedby="push-serving-sizes-description"
    >
      <Box sx={modalBoxStyle}>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </div>
        ) : (
          <Box>
            <Box
              sx={{
                marginBottom: "1rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CheckCircleOutlineOutlinedIcon
                sx={{
                  fontSize: "60px",
                  color: (theme) => theme.palette.success.main,
                }}
              />
            </Box>
            <Box
              sx={{
                marginBottom: "1rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Typography variant="h2" id="push-serving-sizes-title">
                Product Family Updated
              </Typography>
            </Box>
            <Box
              sx={{
                marginBottom: "1rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body1"
                sx={{ textAlign: "center" }}
                id="push-serving-sizes-description"
              >
                Product family serving sizes have been successfully updated.
              </Typography>
              <Typography
                variant="body1"
                sx={{ textAlign: "center", marginTop: 4 }}
              >
                Would you like to push all of these serving sizes to the
                products associated to this family that are already created in
                your library?
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                sx={{ borderRadius: 2 }}
                variant="outlined"
                onClick={closeModal}
              >
                <Typography variant="smallButton">Not Right Now</Typography>
              </Button>
              <Button
                variant="contained"
                sx={{ borderRadius: 2, marginLeft: 2 }}
                onClick={handlePushCallback}
              >
                <Typography variant="smallButton">
                  Push To All Products
                </Typography>
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </Modal>
  );
};

export default PushFamilyServingSizesModal;
